import React, {useState} from 'react';
import axios from "axios";
import {CSRF} from "../../../constants";
import {errorNotify} from "../../../utils/app";
import Button from "../Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faSparkles} from "@awesome.me/kit-a13c95776b/icons/modules/sharp/solid";
import ReactTooltip from "react-tooltip";

const AiAction = ({ msgRef, instructRef, aiFeedbackRef, feedbackRef, instructWrRef, setMessage, pageId, objectId, toneRef, hasBrand, dm=false}) => {
    const [load, setLoad] = useState(false)
    const [tooltipMsg, setTooltipMsg] = useState("")

    const ai_reply = (e) => {
        e.preventDefault()
        setLoad(true)

        const instructionsValue = instructRef?.current?.value
        const toneOfVoiceValue  = toneRef?.current?.value
        const feedbackValue     = feedbackRef?.current?.value

        const formData = new FormData()
        formData.append("page_id", pageId)
        if (instructionsValue) formData.append("instructions", instructionsValue)
        if (toneOfVoiceValue)  formData.append("tone_of_voice", toneOfVoiceValue)
        if (feedbackValue)     formData.append("feedback_instructions", feedbackValue)

        axios({
            method: 'post',
            url: dm ? `/pages/${pageId}/direct_messages/${objectId}/ai_reply` : `/comments/${objectId}/ai_reply`,
            data: formData,
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-Token': CSRF
            }
        })
            .then(response => {
                setLoad(false)
                if (response.data?.success) {
                    const txt = response.data.text
                    if (txt) {
                        // If feedback was provided, clear first; otherwise insert at caret.
                        // Parent setMessage handles Tagify or react-mentions appropriately.
                        setMessage(txt, !!feedbackValue)

                        if (!feedbackValue) {
                            if (aiFeedbackRef?.current) aiFeedbackRef.current.style.display = "block"
                            if (instructWrRef?.current) instructWrRef.current.style.display = "none"
                        }
                        setTooltipMsg("")
                    } else {
                        setTooltipMsg("The agent doesn’t have enough information to reply.")
                        ReactTooltip.show(e.target)
                    }
                } else {
                    errorNotify(response.data.text, true, true)
                }
            })
            .catch(() => {
                setLoad(false)
                errorNotify(response.data.text, true, true)
            }
        );
    }

    return (

        <Button className={`btn ai-btn ${hasBrand ? '' : 'no-brand'}`} dataTip={hasBrand ? tooltipMsg : 'Create an Agent with custom knowledge first.'} clickHandler={ai_reply}>
            Generate
            <FontAwesomeIcon icon={faSparkles} beatFade={load} className="ms-2"/>
        </Button>
    )
}

export default AiAction;
